import Button from '@legacy-vfuk/core-button';
import { withPrefix } from 'gatsby';
import { getImage, getSrc } from 'gatsby-plugin-image';

import {
  BannerImage,
  ButtonWrapper,
  ContentContainer,
  ContentWrapper,
  Description,
  Header,
  HeroBannerContainer,
  Wrapper,
} from './SWHeroBannerWithSubHeader.styles';
import { SWHeroBannerWithSubHeaderProps } from './SWHeroBannerWithSubHeader.types';
import usingOpcoUrl from '@/helpers/prefixHelper';

const SWHeroBannerWithSubHeader = ({
  textPosition,
  description,
  header,
  subHeader,
  backgroundImage,
  textColor,
  primaryButton,
}: SWHeroBannerWithSubHeaderProps) => {
  const backgroundImageSrc = getSrc(backgroundImage) || getImage(backgroundImage)?.placeholder?.fallback || '';
  const getCorrectTextPosition = (position: string | undefined) => {
    if (position === 'center') return 'center';
    if (position === 'right') return 'flex-end';
    if (position === 'left') return 'flex-start';
    return 'flex-end';
  };
  const correctTextPosition = getCorrectTextPosition(textPosition);

  const handleButtonClick = () => {
    window.utag?.view({
      event_name: 'ui_interaction',
      component_name: 'Click Component',
      event_category: 'Get in Touch Form',
      event_label: "Want Us to Call You?",
      event_action: 'Get in Touch Form',
      component_type: 'Button',
    });
  };

  return (
    <Wrapper data-selector="hero banner">
      <BannerImage src={backgroundImageSrc} textPosition={correctTextPosition} alt={backgroundImage.description} />
      <HeroBannerContainer textPosition={correctTextPosition}>
        <ContentContainer>
          <ContentWrapper textColor={textColor} textPosition={correctTextPosition}>
            <Header>{header}</Header>
            <Description>{description}</Description>
            <Header>{subHeader}</Header>
            <ButtonWrapper>
              <Button
                text={primaryButton?.label}
                appearance="secondary"
                inverse
                href={usingOpcoUrl(withPrefix(primaryButton?.url))}
                onClick={handleButtonClick}
                dataSelectorPrefix={header.toLowerCase()}
              />
            </ButtonWrapper>
          </ContentWrapper>
        </ContentContainer>
      </HeroBannerContainer>
    </Wrapper>
  );
};

export default SWHeroBannerWithSubHeader;
